import React from 'react';
import {
  AgnesCard,
  AgnesCardContent,
  AgnesDataTable,
  type AgnesDataTableColumn,
  AgnesPageHeader,
} from '@agnes/ui';
import { SearchInput } from '@/components/SearchInput';
import { comQaNasCelulas } from '@/lib/dataQa';
import { type LinhaCboOcupacao, useCboOcupacoesStore } from '@/stores/useCboOcupacoesStore';
import { SlidersHorizontal } from 'lucide-react';
import { TableWrapper } from '@/components/table-wrapper/TableWrapper';

// célula de texto longo: trunca com tooltip (a tabela já rola no eixo x).
const Cell = ({ v }: { v: string }) => (
  <span className="block max-w-[300px] truncate" title={v}>
    {v || '-'}
  </span>
);

export default function PageCboOcupacoes() {
  const lista = useCboOcupacoesStore((s) => s.lista);
  const total = useCboOcupacoesStore((s) => s.total);
  const page = useCboOcupacoesStore((s) => s.page);
  const size = useCboOcupacoesStore((s) => s.size);
  const carregando = useCboOcupacoesStore((s) => s.carregando);
  const busca = useCboOcupacoesStore((s) => s.busca);

  React.useEffect(() => {
    useCboOcupacoesStore.getState().buscar();
  }, []);

  const columns: AgnesDataTableColumn<LinhaCboOcupacao>[] = [
    { key: 'code', header: 'Código da ocupação', width: 170, render: (r) => r.code },
    { key: 'title', header: 'Título da ocupação', width: 320, render: (r) => <Cell v={r.title} /> },
    {
      key: 'synonyms',
      header: 'Título/Sinônimo',
      width: 320,
      render: (r) => <Cell v={r.synonyms} />,
    },
    {
      key: 'familyCode',
      header: 'Código da família',
      width: 160,
      render: (r) => r.familyCode || '-',
    },
    {
      key: 'family',
      header: 'Título da família',
      width: 300,
      render: (r) => <Cell v={r.family} />,
    },
  ];

  const cols = comQaNasCelulas('cbo-ocupacoes-tabela', columns, (r) => r.code);

  return (
    <>
      <AgnesPageHeader
        dataQa="cbo-ocupacoes-cabecalho"
        icon={<SlidersHorizontal />}
        title="Classificação Brasileira de Ocupações (CBO)"
        subtitle="Relação de ocupações da Classificação Brasileira de Ocupações"
        breadcrumbs={[
          { label: 'Home', href: '/home' },
          { label: 'eSocial' },
          { label: 'Tabelas', href: '/admin/tabelas' },
          { label: 'Classificação Brasileira de Ocupações (CBO)' },
        ]}
      />

      <AgnesCard>
        <AgnesCardContent className="flex items-stretch">
          <div className="mb-3 flex items-center gap-2">
            <SearchInput
              dataQa="cbo-ocupacoes-busca"
              value={busca}
              onValueChange={(v) => useCboOcupacoesStore.getState().setBusca(v)}
              onSearch={() => useCboOcupacoesStore.getState().buscar()}
              placeholder="Pesquisar por título ou ocupação"
            />
          </div>

          <TableWrapper dataQa="cbo-ocupacoes-tabela-card">
            <AgnesDataTable<LinhaCboOcupacao>
              dataQa="cbo-ocupacoes-tabela"
              columns={cols}
              data={lista}
              rowKey={(r) => r.code}
              loading={carregando}
              pagination={{
                page,
                pageSize: size,
                total,
                serverSide: true,
                onPageChange: (p: number) => useCboOcupacoesStore.getState().setPage(p),
                onPageSizeChange: (s: number) => useCboOcupacoesStore.getState().setSize(s),
              }}
            />
          </TableWrapper>
        </AgnesCardContent>
      </AgnesCard>
    </>
  );
}
